import { USER_TELEPHONY_ACTION_TYPE } from '../actions';

const initialState = null;

const userTelephonyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_TELEPHONY_ACTION_TYPE.GET_USER_TELEPHONY:
      return payload;

    default:
      return state;
  }
};

export default userTelephonyReducer;
